import { AlgorithmRepository, ExecutionEnvironment } from '@telespot/domain';

export interface CountAlgorithmsInput {
  searchTerm?: string;
  environmentFilter?: ExecutionEnvironment;
  includeDeprecated?: boolean;
}

export interface ICountAlgorithmsQuery {
  /**
   * Counts algorithms matching the optional search term, environment filter,
   * and deprecation flag. Repository errors propagate so the caller can
   * update its error state.
   */
  execute(input: CountAlgorithmsInput): Promise<number>;
}

export class CountAlgorithmsQuery implements ICountAlgorithmsQuery {
  constructor(private readonly algorithmRepository: AlgorithmRepository) {}

  public async execute(input: CountAlgorithmsInput): Promise<number> {
    return this.algorithmRepository.count(input.searchTerm, input.environmentFilter, input.includeDeprecated);
  }
}
